import { render, staticRenderFns } from "./Cities.vue?vue&type=template&id=4faf5804&scoped=true"
import script from "./Cities.vue?vue&type=script&lang=js"
export * from "./Cities.vue?vue&type=script&lang=js"
import style0 from "./Cities.vue?vue&type=style&index=0&id=4faf5804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf5804",
  null
  
)

export default component.exports